// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFilePdfSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm9 3.5a.5.5 0 0 0 .5.5h3.293a.5.5 0 0 0 .353-.854l-3.292-3.292a.5.5 0 0 0-.854.353zm-4.947 7.314v-1.348h.655c.484 0 .817-.118 1.042-.376.215-.236.328-.58.328-.983 0-.424-.134-.752-.392-.999-.264-.252-.543-.344-1.016-.344H7v4.05zm.344-2.191h-.344v-1.015h.349c.387 0 .575.171.575.51 0 .349-.178.505-.58.505zm2.173-1.859v4.05h1.552c1.069 0 1.993-.934 1.993-2.025 0-1.09-.924-2.025-1.993-2.025zm1.294 3.159h-.242v-2.267h.242c.392 0 .65.107.86.344.188.204.29.488.29.79 0 .3-.102.585-.29.794-.21.237-.468.339-.86.339zM17 11.764h-2.32v4.05h1.052v-1.59h1.15v-.891h-1.15v-.677H17z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFilePdfSolid;
